import { t, TFunction } from 'i18next';
import { API, APIStatus, APIStatusItem, AvailabilityOption, ToolType } from '../types';
import { ToolDescription } from '../events';
import { getBrowserDefaultLanguage } from '../functions';
// flag
import usukFlag from '../../icons/US-UK-flag.png';
import dutchFlag from '../../icons/Netherlands-flag.png';

export const TITLE = 'SRC-NET Prototype';

// language.
export const LANGUAGE_OPTIONS: { value: string; label: string; icon: any }[] = [
  { value: 'en', label: 'English', icon: usukFlag },
  { value: 'nl', label: 'Nederlands', icon: dutchFlag },
];

export const getBrowserPreferredDarkMode = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches;
export const DEFAULT_LANGUAGE = getBrowserDefaultLanguage({ defaultLang: 'en' });
export const DEFAULT_FONT_SIZE = 10;

export const availabilityOptions = (t: TFunction) => [
  //  { label: t('All'), value: 'all' },
  //  { label: t('Active'), value: 'active' },
  //  { label: t('Inactive'), value: 'inactive' },
  //  { label: t('Shutdown'), value: 'shutdown' },
  //  { label: t('Maintenance'), value: 'maintenance' },
  //  { label: t('In-Development'), value: 'in_development' },
  { label: t('All services'), value: 'all' },
  { label: t('Available services'), value: 'available' },
];

export const computeSessionDurationOptions = (t: TFunction) => [
  { label: t('Default (2 days)'), value: '' },
  { label: t('1 Day'), value: '1' },
  { label: t('3 Days'), value: '3' },
  { label: t('1 Week'), value: '7' },
  { label: t('1 Month'), value: '30' },
];

export const SET_UNDEFINED: any = null;

// Initial statuses of external global APIs.
export const API_INITIAL_STATUSES: APIStatusItem[] = [
  { api: API.IAM, status: APIStatus.UNKNOWN },
  { api: API.RUCIO, status: APIStatus.UNKNOWN },
  { api: API.AUTHENTICATION, status: APIStatus.UNKNOWN },
  { api: API.GATEWAY_BACKEND, status: APIStatus.UNKNOWN },
  { api: API.SITE_CAPABILITIES, status: APIStatus.UNKNOWN },
  { api: API.DATA_MANAGEMENT, status: APIStatus.UNKNOWN },
  { api: API.PERMISSIONS, status: APIStatus.UNKNOWN },
];

// Map of external global APIs to text used for them on status panel in UI.
export const API_TITLES = new Map<API, string>([
  [API.IAM, 'IAM'],
  [API.RUCIO, 'Rucio'],
  [API.AUTHENTICATION, 'Authentication API'],
  [API.GATEWAY_BACKEND, 'Science Gateway API'],
  [API.SITE_CAPABILITIES, 'Site Capabilities API'],
  [API.DATA_MANAGEMENT, 'Data Management API'],
  [API.PERMISSIONS, 'Permissions API'],
]);

// Map of API statuses to indicator colours.
export const API_STATUS_COLOURS = new Map<APIStatus, string>([
  [APIStatus.RUNNING, 'G'],
  [APIStatus.STOPPED, 'R'],
  [APIStatus.UNKNOWN, 'U'],
]);
